import { render, staticRenderFns } from "./ShopeeVoucher.vue?vue&type=template&id=2e74ff54&"
import script from "./ShopeeVoucher.vue?vue&type=script&lang=js&"
export * from "./ShopeeVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports